import { UserExtraData, UserProfile } from "../../models";
import { UserToken } from "../../types/token/token";


interface EditProfileResult {
    ok: string
}

export default class UserService {
    #token: UserToken = null
    #url: string = ''
    constructor(token: UserToken) {
        this.#token = token;
    }

    getHeaders() {
        return {
            'Authorization': 'Bearer ' + this.#token
        };
    }

    postHeaders() {
        return {
            'Authorization': 'Bearer ' + this.#token,
            'Content-Type': 'application/json'
        };
    }

    setToken = (token: UserToken, url?: string) => {
        this.#token = token;
        this.#url = url ?? '';
    }

    getToken() {
        return this.#token;
    }

    async getUserData(userUid: string): Promise<{val: (UserExtraData & UserProfile) | null, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/getOtherUserFullData?id=${userUid}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: null}
            const responseBodyText = await res.json()

            const result: UserExtraData & UserProfile = responseBodyText
            return {
                isAborted: false,
                val: result ?? null
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: null, isAborted: true}
            }

            return {isAborted: false, val: null}
        }
    }

    async updateFirstName(firstname: (UserExtraData & UserProfile)['firstname']): Promise<{val: boolean, isAborted: boolean}> {
        try {         
            const address = `${this.#url}/usersettings/update-firstname?firstname=${firstname}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateLastName(lastname: (UserExtraData & UserProfile)['lastname']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-lastname?lastname=${lastname}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateImage(profileImageUrl: (UserExtraData & UserProfile)['profileImageUrl']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-profileImage?profileImageUrl=${profileImageUrl}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateTitle(title: (UserExtraData & UserProfile)['title']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-title?title=${title}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateNickname(nickname: (UserExtraData & UserProfile)['nickname']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-nickname?nickname=${nickname}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateBio(bio: (UserExtraData & UserProfile)['bio']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-bio?bio=${bio}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updatePhone(phone: (UserExtraData & UserProfile)['phone']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-phone?phone=${phone}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updatePhone2(phone2: (UserExtraData & UserProfile)['phone2']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-phone2?phone2=${phone2}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateHomeAddress(homeAddress: (UserExtraData & UserProfile)['homeAddress']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-homeAddress?homeAddress=${homeAddress}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateOfficeAddress(officeAddress: (UserExtraData & UserProfile)['officeAddress']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-officeAddress?officeAddress=${officeAddress}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateBirthday(birthday: (UserExtraData & UserProfile)['birthday']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-birthday?birthday=${birthday}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateTag(tag: (UserExtraData & UserProfile)['tag']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-tag?tag=${tag}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateLang(lang: (UserExtraData & UserProfile)['lang']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-lang?lang=${lang}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }
    async updateSignature(signature: (UserExtraData & UserProfile)['signature']): Promise<{val: boolean, isAborted: boolean}> {
        try {            
            const address = `${this.#url}/usersettings/update-signature?signature=${signature}`
            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })

            if (!res) return {isAborted: false, val: false}
            const responseBodyText = await res.json()

            const result: EditProfileResult = responseBodyText
            return {
                isAborted: false,
                val: result.ok === 'ok'
            }

        }
        catch (err) {
            //@ts-ignore
            if (err.name == 'AbortError') {
                return {val: false, isAborted: true}
            }

            return {isAborted: false, val: false}
        }
    }

}

